/* ============================================================
   PM CART v3 — drawer + cart page controller
   ============================================================ */
(function () {
  'use strict';

  // ─── Auto-refresh the cart drawer whenever ANY code path (theme, apps,
  // essential-upsell, etc.) mutates the Shopify cart via /cart/add.js /
  // /cart/change.js / /cart/update.js. Our own code paths (changeLine,
  // addVariant, etc.) already refresh after their calls, but third-party
  // apps have no way to signal our drawer — so we refresh defensively when
  // the response comes back. Rate-limited so a burst of calls only fires
  // one refresh at the tail.
  var _pmcRefreshTimer = null;
  function schedulePmcRefresh() {
    if (_pmcRefreshTimer) clearTimeout(_pmcRefreshTimer);
    _pmcRefreshTimer = setTimeout(function () {
      _pmcRefreshTimer = null;
      if (typeof refreshActive === 'function') refreshActive();
      /* Broadcast a cart-mutation event so GWP reconcilers (and anything
         else that needs to react to real cart state changes) can re-run
         without each hooking its own fetch/XHR proxy. */
      try { document.dispatchEvent(new CustomEvent('pm:cart:mutated')); } catch (_) {}
    }, 250);
  }
  function isCartMutationUrl(u) {
    if (!u) return false;
    var s = String(u);
    return s.indexOf('/cart/add') > -1 || s.indexOf('/cart/change') > -1 || s.indexOf('/cart/update') > -1;
  }
  function isCartAddUrl(u) {
    if (!u) return false;
    return String(u).indexOf('/cart/add') > -1;
  }
  (function () {
    var _fetch = window.fetch;
    window.fetch = function (url, opts) {
      var u = (typeof url === 'string') ? url : (url && url.url) || '';
      var p = _fetch.apply(this, arguments);
      if (isCartMutationUrl(u)) {
        p.then(function () {
          schedulePmcRefresh();
          /* Dedicated "add" event — popup/upsell flows subscribe here
             without also firing on removes or qty changes. */
          if (isCartAddUrl(u)) {
            try { document.dispatchEvent(new CustomEvent('pm:cart:added')); } catch (_) {}
          }
        }).catch(function () {});
      }
      return p;
    };
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) {
      this.__pmcUrl = u;
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (isCartMutationUrl(this.__pmcUrl)) {
        var wasAdd = isCartAddUrl(this.__pmcUrl);
        this.addEventListener('load', function () {
          schedulePmcRefresh();
          if (wasAdd) {
            try { document.dispatchEvent(new CustomEvent('pm:cart:added')); } catch (_) {}
          }
        });
      }
      return _send.apply(this, arguments);
    };
  })();

  var DRAWER_SECTION = 'cart-drawer-contents';
  var PAGE_SECTION = 'cart-main';
  var SWAP_IDS = ['cart-qualifications', 'cart-spend-gwp-progress', 'cart-items', 'cart-upsell-strip', 'cart-footer-summary'];

  var symbol = (document.body.getAttribute('data-currency-symbol') || '€');

  function money(cents) {
    var n = (parseFloat(cents) || 0) / 100;
    var s = n.toFixed(2);
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return symbol + s;
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function fetchSection(section) {
    var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/';
    return fetch(url + '?section_id=' + section, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); });
  }

  function swapFrom(html, container) {
    if (!container) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    SWAP_IDS.forEach(function (id) {
      var fresh = doc.getElementById(id);
      var live = container.querySelector('#' + id);
      if (fresh && live) live.replaceWith(fresh);
    });
    var countEl = doc.querySelector('[data-cart-count]');
    return countEl ? parseInt(countEl.getAttribute('data-cart-count'), 10) : null;
  }

  function setEmptyState(scope, count) {
    if (!scope) return;
    var empty = scope.querySelector('#cart-empty');
    var hideWhenEmpty = scope.querySelectorAll('.drawer-footer, .pmc-summary, .pmc-upsell, .pmc-trust, .pmc-promo, .pmc-routine, .pmc-recent');
    if (count === 0) {
      if (empty) empty.style.display = 'block';
      hideWhenEmpty.forEach(function (el) { el.style.display = 'none'; });
    } else {
      if (empty) empty.style.display = 'none';
      hideWhenEmpty.forEach(function (el) { el.style.removeProperty('display'); });
    }
  }

  function scrim(scope, on) {
    if (!scope) return;
    var s = scope.querySelector('#cart-loading-scrim');
    if (s) s.classList.toggle('active', !!on);
  }

  function refreshDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return Promise.resolve();
    scrim(drawer, true);
    return fetchSection(DRAWER_SECTION).then(function (html) {
      var count = swapFrom(html, drawer);
      var badge = drawer.querySelector('[data-cart-drawer-count]');
      if (badge && count != null) badge.textContent = count;
      setEmptyState(drawer, count);
      scrim(drawer, false);
    }).catch(function () { scrim(drawer, false); });
  }

  function refreshPage() {
    var page = document.querySelector('.pmc-cart');
    if (!page) return Promise.resolve();
    scrim(page, true);
    return fetchSection(PAGE_SECTION).then(function (html) {
      var count = swapFrom(html, page);
      var ct = page.querySelector('[data-cart-page-count]');
      if (ct && count != null) ct.textContent = count + (count === 1 ? ' item' : ' items');
      setEmptyState(page, count);
      document.querySelectorAll('.pmc-routine, .pmc-recent').forEach(function (el) {
        if (count === 0) el.style.display = 'none'; else el.style.removeProperty('display');
      });
      scrim(page, false);
    }).catch(function () { scrim(page, false); });
  }

  function refreshActive() {
    if (document.querySelector('.pmc-cart')) return refreshPage();
    return refreshDrawer();
  }

  function sweepGwpOrphans() {
    var container = document.querySelector('.pmc-cart') || document.getElementById('cart-drawer');
    if (!container) return Promise.resolve(false);
    var lines = container.querySelectorAll('#cart-items .pmc-line');
    if (!lines.length) return Promise.resolve(false);
    var parentIds = {};
    lines.forEach(function (l) {
      if (!l.hasAttribute('data-gwp-parent-id')) {
        var vid = l.getAttribute('data-variant-id');
        if (vid) parentIds[vid] = true;
      }
    });
    var updates = {};
    lines.forEach(function (l) {
      var pid = l.getAttribute('data-gwp-parent-id');
      if (pid && !parentIds[pid]) {
        var key = l.getAttribute('data-line-item-key');
        if (key) updates[key] = 0;
      }
    });
    if (!Object.keys(updates).length) return Promise.resolve(false);
    return postJSON('/cart/update.js', { updates: updates })
      .then(function () { return refreshActive(); })
      .then(function () { return true; })
      .catch(function () { return false; });
  }

  function changeLine(key, qty, scope, parentVariantId) {
    scrim(scope, true);
    /* When a line that is a GWP PARENT changes qty / is removed, every
       child line with data-gwp-parent-id === this variant must move with
       it. Previous version used querySelector (singular) and only moved
       the first match — any additional GWPs linked to the same parent
       were orphaned until sweepGwpOrphans ran. Iterating all matches now. */
    var gwpChildren = parentVariantId
      ? document.querySelectorAll('.pmc-line[data-gwp-parent-id="' + parentVariantId + '"]')
      : [];
    if (gwpChildren.length) {
      var updates = {};
      updates[key] = qty;
      gwpChildren.forEach(function (child) {
        var childKey = child.getAttribute('data-line-item-key');
        if (childKey) updates[childKey] = qty;
      });
      return postJSON('/cart/update.js', { updates: updates })
        .then(function () { return refreshActive(); })
        .catch(function () { scrim(scope, false); });
    }
    return postJSON('/cart/change.js', { id: key, quantity: qty })
      .then(function () { return refreshActive(); })
      .catch(function () { scrim(scope, false); });
  }

  function addVariant(variantId, qty) {
    return postJSON('/cart/add.js', { items: [{ id: variantId, quantity: qty || 1 }] })
      .then(function () { return refreshActive(); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var dec = e.target.closest('.pmc-qty-dec');
    var inc = e.target.closest('.pmc-qty-inc');
    var rem = e.target.closest('.pmc-line .pmc-remove');
    var addBtn = e.target.closest('[data-pmc-add]');
    var addAll = e.target.closest('[data-pmc-add-all]');

    if (dec || inc) {
      var item = e.target.closest('.pmc-line');
      if (!item) return;
      var input = item.querySelector('.pmc-qty-input');
      var step = parseInt(input && input.getAttribute('step'), 10) || 1;
      var cur = parseInt(input && input.value, 10) || 0;
      var next = inc ? cur + step : Math.max(0, cur - step);
      if (next === cur) return;
      changeLine(item.getAttribute('data-line-item-key'), next, item.closest('.pmc-cart') || item.closest('#cart-drawer'), item.getAttribute('data-variant-id'));
      return;
    }

    if (rem) {
      e.preventDefault();
      var ri = rem.closest('.pmc-line');
      if (!ri) return;
      changeLine(ri.getAttribute('data-line-item-key'), 0, ri.closest('.pmc-cart') || ri.closest('#cart-drawer'), ri.getAttribute('data-variant-id'));
      return;
    }

    if (addBtn) {
      e.preventDefault();
      var vid = addBtn.getAttribute('data-variant-id');
      if (!vid || addBtn.disabled) return;
      var label = addBtn.textContent;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      addVariant(vid, 1)
        .then(function () { addBtn.textContent = 'Added ✓'; })
        .catch(function () { addBtn.textContent = 'Try again'; })
        .finally(function () {
          setTimeout(function () { addBtn.disabled = false; addBtn.textContent = label; }, 1400);
        });
      return;
    }

    if (addAll) {
      e.preventDefault();
      var ids = (addAll.getAttribute('data-pmc-add-all') || '').split(',').filter(Boolean);
      if (!ids.length || addAll.disabled) return;
      var lbl = addAll.textContent;
      addAll.disabled = true; addAll.textContent = 'Adding…';
      postJSON('/cart/add.js', { items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
        .then(function () { return refreshActive(); })
        .then(function () { addAll.textContent = 'Added ✓'; })
        .catch(function () { addAll.textContent = 'Try again'; })
        .finally(function () {
          setTimeout(function () { addAll.disabled = false; addAll.textContent = lbl; }, 1400);
        });
    }
  });

  function bridgeCartRefresh() {
    if (typeof window.cart === 'undefined' && typeof cart === 'undefined') return false;
    try {
      var c = (typeof cart !== 'undefined') ? cart : window.cart;
      if (c && !c.__pmcBridged) { c.refresh = refreshDrawer; c.__pmcBridged = true; }
      return true;
    } catch (e) { return false; }
  }
  if (!bridgeCartRefresh()) {
    var tries = 0, iv = setInterval(function () { if (bridgeCartRefresh() || ++tries > 40) clearInterval(iv); }, 100);
  }

  (function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () {
      document.body.classList.toggle('pmc-cart-open', drawer.classList.contains('active'));
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sweepGwpOrphans(); });
  } else {
    sweepGwpOrphans();
  }

  function recCardImg(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    return img ? '<span class="ip"><img src="' + img + '" alt="" loading="lazy"></span>' : '<span class="ip"></span>';
  }
  function fetchRecs(pid, intents, limit) {
    intents = intents.slice();
    function tryNext() {
      if (!pid || !intents.length) return Promise.resolve([]);
      var intent = intents.shift();
      return fetch('/recommendations/products.json?product_id=' + pid + '&intent=' + intent + '&limit=' + limit, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { var ps = (d && d.products) || []; return ps.length ? ps : tryNext(); })
        .catch(function () { return tryNext(); });
    }
    return tryNext();
  }

  var RV_KEY = 'pmc_recently_viewed';
  function getRV() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; } }
  function recordPDP() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];
    var list = getRV().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8))); } catch (e) {}
  }
  recordPDP();

  function escAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escText(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  /* Fetch each product's canonical card server-rendered via Section Rendering
     API — /products/{handle}?sections=pnm-product-card-single — so the cart
     "Recently viewed" cards inherit every metafield the collection page has
     (subtitle, ribbon, rating, wishlist heart) with zero client duplication. */
  function fetchCardHtml(handle) {
    return fetch('/products/' + handle + '?sections=pnm-product-card-single', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return j && j['pnm-product-card-single'] ? j['pnm-product-card-single'] : ''; })
      .catch(function () { return ''; });
  }
  function renderRecent(handles, row, wrap) {
    var slice = handles.filter(Boolean).slice(0, 4);
    if (!slice.length) { wrap.hidden = true; return; }
    Promise.all(slice.map(fetchCardHtml)).then(function (htmls) {
      var joined = htmls.filter(Boolean).join('');
      if (!joined) { wrap.hidden = true; return; }
      row.innerHTML = joined;
      wrap.hidden = false;
    });
  }
  function recentFallback(wrap, row) {
    var fid = wrap.getAttribute('data-recent-fallback-id');
    fetchRecs(fid, ['related', 'complementary'], 4).then(function (products) {
      if (!products.length) { wrap.hidden = true; return; }
      renderRecent(products.map(function (p) { return p.handle; }), row, wrap);
    });
  }
  function hydrateRecentlyViewed() {
    var wrap = document.querySelector('.pmc-recent');
    if (!wrap) return;
    var row = wrap.querySelector('.row4');
    if (!row) return;
    var cartHandles = (wrap.getAttribute('data-cart-handles') || '').split(',').filter(Boolean);
    var handles = getRV().filter(function (h) { return cartHandles.indexOf(h) === -1; }).slice(0, 4);
    if (!handles.length) { recentFallback(wrap, row); return; }
    renderRecent(handles, row, wrap);
  }

  function hydrateRoutine() {
    var wrap = document.querySelector('.pmc-routine');
    if (!wrap) return;
    var pid = wrap.getAttribute('data-routine-product-id');
    var row = wrap.querySelector('.row3');
    if (!pid || !row) { wrap.hidden = true; return; }
    fetchRecs(pid, ['complementary', 'related'], 3).then(function (products) {
      if (!products.length) { wrap.hidden = true; return; }
      var bundle = [];
      row.innerHTML = products.map(function (p) {
        var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
        if (variant && variant.available !== false) bundle.push({ id: variant.id, price: p.price });
        var price = '<b>' + money(p.price) + '</b>';
        if (p.compare_at_price && p.compare_at_price > p.price) {
          price += ' <span class="was">' + money(p.compare_at_price) + '</span>';
        }
        var addBtn = variant
          ? '<button class="add" data-pmc-add data-variant-id="' + variant.id + '">+ Add to bag</button>'
          : '<button class="add" disabled>Sold out</button>';
        return '<div class="pmc-ritem">' + recCardImg(p) +
          '<h5>' + p.title + '</h5>' +
          '<p class="pr">' + price + '</p>' + addBtn + '</div>';
      }).join('');
      var cta = wrap.querySelector('.cta');
      if (cta && bundle.length > 1) {
        var total = bundle.reduce(function (s, b) { return s + (b.price || 0); }, 0);
        var ids = bundle.map(function (b) { return b.id; }).join(',');
        cta.innerHTML = '<span class="save-line">Add all ' + bundle.length + ' to your routine · <b>' + money(total) + '</b></span>' +
          '<button class="add-all" data-pmc-add-all="' + ids + '">Add routine</button>';
        cta.hidden = false;
      } else if (cta) { cta.hidden = true; }
      wrap.hidden = false;
    });
  }

  function hydrateModules() { hydrateRoutine(); hydrateRecentlyViewed(); }

  /* Delegated click handler for the metaobject-driven cart upsell strip.
     Bound once here so it survives every DOM swap of #cart-upsell-strip
     (inline scripts inside swapped HTML don't execute per HTML spec).
     Handles arrow scroll (scoped to nearest strip) + Add-to-cart. */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('[data-pmc-prev-a],[data-pmc-next-a],[data-pmc-prev-b],[data-pmc-next-b]');
    if (arrow) {
      var container = arrow.closest('.pmc-inline-upsell');
      var row = container && container.querySelector('.pmc-inline-upsell__row');
      if (!row) return;
      var card = row.querySelector('.pmc-inline-upsell__card');
      var step = (card ? card.offsetWidth : 148) + 10;
      var dir = (arrow.hasAttribute('data-pmc-next-a') || arrow.hasAttribute('data-pmc-next-b')) ? 1 : -1;
      row.scrollBy({ left: dir * step, behavior: 'smooth' });
      return;
    }
    var btn = e.target.closest && e.target.closest('.pmc-inline-upsell__add');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    var f = btn.getAttribute('data-eu-funnel-id');
    var p = btn.getAttribute('data-eu-product-id');
    var props = {};
    if (f) props['__essential_upsell_funnel_id']  = f;
    if (p) props['__essential_upsell_product_id'] = p;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
    })
    .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
    .then(function (res) { if (!res.ok) throw res.body; })
    .catch(function () { btn.disabled = false; });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateModules);
  } else {
    hydrateModules();
  }
})();

/* ============================================================
   Open-cart-drawer via URL param — Klaviyo (and any other email
   / marketing link) can send shoppers to a PDP with the drawer
   already open by appending ?open_cart=1 to the URL. We fire the
   same pm:cart-drawer:open event the rest of the theme uses, then
   strip the param so refreshes don't re-fire it.
   ============================================================ */
(function () {
  try {
    var url = new URL(window.location.href);
    if (url.searchParams.get('open_cart') === '1') {
      url.searchParams.delete('open_cart');
      var clean = url.pathname + (url.search ? url.search : '') + url.hash;
      window.history.replaceState({}, '', clean);
      /* Defer one frame so page-load listeners are attached first. */
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('pm:cart-drawer:open'));
      }, 300);
    }
  } catch (e) {}
})();

/* ============================================================
   GWP auto-add — minimal page-load hook. Reads the JSON emitted
   by snippets/pnm-gwp-auto-add.liquid and, for every campaign
   whose schedule is in window AND trigger product is present
   in the cart AND free variant is NOT present, POSTs a single
   /cart/add.js. Add-only — no qty reconciliation, no removal.

   Fires on page load, on drawer open, and via a one-shot timer
   at the schedule start boundary — so a shopper who added Erase
   on Tuesday and reloads any page Friday morning sees the free
   GWP in their drawer without touching anything.
   ============================================================ */
(function () {
  var configEl = document.getElementById('pnm-gwp-auto-add');
  if (!configEl) return;
  var campaigns;
  try { campaigns = JSON.parse(configEl.textContent || '[]'); } catch (e) { return; }
  if (!Array.isArray(campaigns) || !campaigns.length) return;

  var busy = false;
  var done = {}; /* trigger_product_id -> true once handled this page view */

  /* Persistent "already added" flag per campaign start — so we only
     auto-add the GWP ONCE per shopper. After that first add, if they
     remove it manually or edit the cart, we do NOT re-add on the next
     page load. Storage key includes starts_at so a NEW campaign (new
     start date) resets and can auto-add again. */
  function addedKey(c) { return 'pnm_gwp_added:' + c.trigger_product_id + ':' + c.starts_at; }
  function alreadyAdded(c) {
    try { return localStorage.getItem(addedKey(c)) === '1'; } catch (e) { return false; }
  }
  function markAdded(c) {
    try { localStorage.setItem(addedKey(c), '1'); } catch (e) {}
  }

  function inWindow(c) {
    /* starts_at is required — a campaign without a start date is treated
       as un-scheduled and never fires (prevents an "always on" accident
       when the merchant hasn't configured a schedule).
       ends_at is OPTIONAL — missing = runs forever from starts_at (useful
       for open-ended "live GWP" promos the merchant turns off manually by
       clearing the metafield). */
    if (c.starts_at == null) return false;
    var s = parseInt(c.starts_at, 10) || 0;
    if (s <= 0) return false;
    var now = Math.floor(Date.now() / 1000);
    if (now < s) return false;
    if (c.ends_at != null) {
      var e = parseInt(c.ends_at, 10) || 0;
      if (e > 0 && now >= e) return false;
    }
    return true;
  }

  function refreshVisibleCart() {
    if (document.querySelector('.pmc-cart') && typeof refreshPage === 'function') return refreshPage();
    if (document.getElementById('cart-drawer') && typeof refreshDrawer === 'function') return refreshDrawer();
    return Promise.resolve();
  }

  function run() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        var byProduct = {}, byVariant = {}, variantsByProduct = {};
        /* Lines with _gwp_parent_id are the auto-added free items — track
           them by variant so we can tell "GWP already added" apart from
           "shopper has this variant as a paid line". Critical for the
           same-SKU BOGO case where trigger and GWP share a variant. */
        var gwpLinesByVariant = {};
        var paidQtyByVariant = {};
        cart.items.forEach(function (it) {
          var pid = String(it.product_id);
          var vid = String(it.variant_id);
          var isGwp = it.properties && it.properties._gwp_parent_id;
          if (isGwp) {
            gwpLinesByVariant[vid] = true;
          } else {
            paidQtyByVariant[vid] = (paidQtyByVariant[vid] || 0) + it.quantity;
            byProduct[pid] = (byProduct[pid] || 0) + it.quantity;
            /* Track ALL PAID parent variants for this product, so the
               highest-qty parent anchors _gwp_parent_id — protects the
               GWP line from sweepGwpOrphans when other variants come
               and go. */
            if (!variantsByProduct[pid]) variantsByProduct[pid] = [];
            variantsByProduct[pid].push({ vid: vid, qty: it.quantity });
          }
          byVariant[vid] = true;
        });
        function pickParentVariant(pid) {
          var list = variantsByProduct[pid] || [];
          if (!list.length) return null;
          list.sort(function (a, b) { return b.qty - a.qty; });
          return list[0].vid;
        }
        var adds = [];
        campaigns.forEach(function (c) {
          var pid = String(c.trigger_product_id || '');
          /* Prefer the new array of GWP variant ids. Fall back to the
             legacy singular free_variant_id for older snippet output. */
          var vids = Array.isArray(c.free_variant_ids) && c.free_variant_ids.length
            ? c.free_variant_ids.map(function (v) { return String(v); })
            : (c.free_variant_id != null ? [String(c.free_variant_id)] : []);
          vids = vids.filter(function (v) { return v && v !== 'null' && v !== 'undefined'; });
          if (!pid || !vids.length) return;
          if (done[pid]) return;
          if (!inWindow(c)) return;
          if (!byProduct[pid]) return;
          /* Already-added guard — once per shopper per campaign start.
             The campaign is marked done as soon as ANY of its GWP variants
             were previously handled; prevents re-adding on later loads. */
          if (alreadyAdded(c)) { done[pid] = true; return; }
          /* Per-variant skip — if a GWP line for a specific variant is
             already present, don't re-add just THAT one. Other GWPs in
             the same campaign still get added. */
          var parentVid = pickParentVariant(pid) || pid;
          /* Attach the trigger product's custom.gwp_funnel_id (emitted as
             c.funnel_id by pnm-gwp-auto-add.liquid) as the
             __essential_upsell_funnel_id line property on every free item
             so Essential Upsell applies its free-gift discount per line. */
          var funnelId = c.funnel_id || null;
          var pushedAny = false;
          vids.forEach(function (vid) {
            if (gwpLinesByVariant[vid]) return;
            var gwpProps = { '_gwp_parent_id': parentVid };
            if (funnelId) gwpProps.__essential_upsell_funnel_id = funnelId;
            adds.push({
              id: parseInt(vid, 10),
              quantity: byProduct[pid],
              properties: gwpProps
            });
            pushedAny = true;
          });
          done[pid] = true;
          markAdded(c);
        });
        if (!adds.length) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: adds })
        }).then(refreshVisibleCart);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  campaigns.forEach(function (c) {
    var s = parseInt(c.starts_at, 10) || 0;
    if (!s) return;
    var delayMs = (s - Math.floor(Date.now() / 1000)) * 1000;
    if (delayMs > 0 && delayMs < 24 * 3600 * 1000) {
      setTimeout(run, delayMs + 250);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('pm:cart-drawer:open', run);
})();

/* ============================================================
   Campaign countdown ticker — updates every .pnm-countdown span
   once per second. Rescans the DOM on each tick so it just works
   across cart drawer / cart page SWAP_IDS rebuilds, no re-bind
   needed after cart mutations.
   ============================================================ */
(function () {
  function fmt(nSec) {
    if (nSec <= 0) return '0s';
    var d = Math.floor(nSec / 86400);
    var h = Math.floor((nSec % 86400) / 3600);
    var m = Math.floor((nSec % 3600) / 60);
    var s = nSec % 60;
    if (d > 0) return d + 'd ' + h + 'h ' + m + 'm';
    if (h > 0) return h + 'h ' + m + 'm ' + s + 's';
    if (m > 0) return m + 'm ' + s + 's';
    return s + 's';
  }
  function tick() {
    var now = Math.floor(Date.now() / 1000);
    var els = document.querySelectorAll('.pnm-countdown');
    els.forEach(function (el) {
      var startsAt = parseInt(el.getAttribute('data-starts-at'), 10) || 0;
      var endsAt   = parseInt(el.getAttribute('data-ends-at'),   10) || 0;
      var preLabel  = el.getAttribute('data-pre-label')  || 'FREE IN';
      var liveLabel = el.getAttribute('data-live-label') || 'ENDS IN';
      if (endsAt <= 0 || now >= endsAt) {
        /* Campaign over — hide the countdown; keeps DOM if it comes back */
        el.textContent = '';
        el.setAttribute('hidden', '');
        return;
      }
      el.removeAttribute('hidden');
      if (now < startsAt) {
        el.textContent = preLabel + ' ' + fmt(startsAt - now);
      } else {
        el.textContent = liveLabel + ' ' + fmt(endsAt - now);
      }
    });
  }
  tick();
  setInterval(tick, 1000);
})();

/* ==============================================================
   Spend-threshold GWP auto-add + remove.

   Reads JSON emitted by snippets/pnm-spend-gwp-auto-add.liquid
   (one entry per active cart_spend_gwp tier, already resolved
   for the shopper's currency).

   On every reconcile pass:
     - Compute PAID subtotal (cart.items_subtotal_price minus
       any lines flagged as GWP via _spend_gwp_tier_id or
       _gwp_parent_id).
     - For each tier:
         * if paid >= threshold AND tier's gift NOT in cart → add
         * if paid <  threshold AND tier's gift IS   in cart → remove

   Properties on added lines:
     _spend_gwp_tier_id = metaobject gid (identifies the tier)
     _spend_gwp_free    = 1

   Runaway-add safety: in-memory + sessionStorage guard records
   each (tier_id, vid) we've successfully added. Even if the next
   /cart.js read is stale/cached and misses our new line, we
   won't double-add. The guard is cleared the moment we actually
   observe the gift gone from the cart, so a legitimate manual
   remove still allows re-adding.
   ============================================================== */
(function () {
  var cfgEl = document.getElementById('pnm-spend-gwp-auto-add');
  if (!cfgEl) return;
  var tiers;
  try { tiers = JSON.parse(cfgEl.textContent || '[]'); } catch (e) { return; }
  if (!Array.isArray(tiers) || !tiers.length) return;

  tiers.sort(function (a, b) {
    return (a.threshold_cents || 0) - (b.threshold_cents || 0);
  });

  var busy = false;
  var queued = false;
  var SESSION_KEY = 'pnm_spend_gwp_added_v1';
  /* Marks exist only to prevent within-reconcile runaway adds while the
     cart.js read is still catching up with our just-posted writes. Once a
     reconcile pass settles, the next pass should trust the live cart —
     NOT a stale sessionStorage flag. 10s is well past Shopify's write +
     cache-busted read round-trip but short enough that any manual cart
     tinkering between pages recovers cleanly. */
  var MARK_TTL_MS = 10000;

  function readMarks() {
    try { return JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}') || {}; }
    catch (e) { return {}; }
  }
  function writeMarks(obj) {
    try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(obj)); } catch (e) {}
  }
  function markAdded(tier_id, vid) {
    var m = readMarks();
    m[tier_id + '::' + vid] = Date.now();
    writeMarks(m);
  }
  function clearMark(tier_id, vid) {
    var m = readMarks();
    delete m[tier_id + '::' + vid];
    writeMarks(m);
  }
  function isMarked(tier_id, vid) {
    var m = readMarks();
    var ts = m[tier_id + '::' + vid] || 0;
    if (!ts) return false;
    if (Date.now() - ts > MARK_TTL_MS) {
      /* Expired — drop it from storage so later checks are cheap. */
      delete m[tier_id + '::' + vid];
      writeMarks(m);
      return false;
    }
    return true;
  }

  /* On IIFE load, sweep expired marks AND clear ANY mark whose gift is
     not actually in the cart. This heals carts left broken by a previous
     bug (e.g. a stale mark from a prior session preventing re-add on a
     cart that now qualifies). We only trust marks that still align with
     live cart state. */
  (function sweepStaleMarks() {
    var m = readMarks();
    var now = Date.now();
    var changed = false;
    Object.keys(m).forEach(function (k) {
      if (now - (m[k] || 0) > MARK_TTL_MS) {
        delete m[k];
        changed = true;
      }
    });
    if (changed) writeMarks(m);
  })();

  function refreshVisibleCart() {
    if (document.querySelector('.pmc-cart') && typeof refreshPage === 'function') return refreshPage();
    if (document.getElementById('cart-drawer') && typeof refreshDrawer === 'function') return refreshDrawer();
    return Promise.resolve();
  }

  function run() {
    if (busy) { queued = true; return; }
    busy = true;
    fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return null;

        var paid = 0;
        var presentByTier = {}; /* tier_id -> { vid -> line key } */
        var qtyFixUpdates = {}; /* line key -> target quantity (for self-heal) */
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          var tierId = p._spend_gwp_tier_id || null;
          /* Prefer `final_line_price` (post-discount paid) over the
             deprecated `line_price` (which is ambiguous across cart
             configurations). Fall back to `price * quantity` only
             when neither is present. */
          var linePaid = (typeof it.final_line_price === 'number' ? it.final_line_price : null);
          if (linePaid == null) linePaid = (typeof it.line_price === 'number' ? it.line_price : null);
          if (linePaid == null) linePaid = (it.price || 0) * (it.quantity || 0);
          /* A line is a FREE gift and must NOT count toward paid when:
             1) it belongs to a spend-GWP tier (auto-added), OR
             2) its paid value is actually 0 (classic Essential-Upsell
                GWP freebie that gets zeroed by a Shopify Automatic
                Discount), OR
             3) it carries an explicit free-gift property.
             Routine upsell lines also carry `_gwp_parent_id` for cart
             cascade removal but are PAID items (non-zero price) — so
             presence of `_gwp_parent_id` alone is NOT enough to exclude. */
          var isFreeGift = !!tierId
            || p._spend_gwp_free === '1'
            || p._gwp_free === '1'
            || (!!p._gwp_parent_id && (linePaid || 0) <= 0);
          if (tierId) {
            if (!presentByTier[tierId]) presentByTier[tierId] = {};
            presentByTier[tierId][String(it.variant_id)] = it.key;
            /* Self-heal: a spend-GWP line should ALWAYS be qty 1. If a
               previous runaway bug left a line at qty > 1, repair it in
               the same reconcile pass so the cart converges without
               manual cleanup by the shopper. */
            if ((it.quantity || 0) > 1) qtyFixUpdates[it.key] = 1;
          } else if (!isFreeGift) {
            paid += linePaid;
          }
        });

        var adds = [];
        var removes = [];
        var postAddMarks = []; /* [tier_id, vid] to mark after a successful add */

        tiers.forEach(function (t) {
          var thr = parseInt(t.threshold_cents, 10) || 0;
          var vids = Array.isArray(t.free_variant_ids) && t.free_variant_ids.length
            ? t.free_variant_ids.map(function (v) { return String(v); })
            : (t.free_variant_id != null ? [String(t.free_variant_id)] : []);
          vids = vids.filter(function (v) { return v && v !== 'null' && v !== 'undefined'; });
          if (!thr || !vids.length) return;

          var qualifies = paid >= thr;
          var present = presentByTier[t.tier_id] || {};

          if (qualifies) {
            vids.forEach(function (vid) {
              if (present[vid]) return;
              if (isMarked(t.tier_id, vid)) return;
              adds.push({
                id: parseInt(vid, 10),
                quantity: 1,
                properties: {
                  _spend_gwp_tier_id: String(t.tier_id),
                  _spend_gwp_free: '1'
                }
              });
              postAddMarks.push([t.tier_id, vid]);
            });
          } else {
            /* Doesn't qualify — remove every line tagged with this tier
               and clear the session marks so they can re-add later. */
            Object.keys(present).forEach(function (vid) {
              removes.push(present[vid]);
              clearMark(t.tier_id, vid);
            });
            /* Also clear any stale marks for this tier whose vids aren't
               even in cart — avoids a stuck mark preventing re-add. */
            vids.forEach(function (vid) { if (!present[vid]) clearMark(t.tier_id, vid); });
          }
        });

        var qtyFixKeys = Object.keys(qtyFixUpdates);
        if (!adds.length && !removes.length && !qtyFixKeys.length) return null;

        var chain = Promise.resolve();
        qtyFixKeys.forEach(function (key) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, quantity: qtyFixUpdates[key] })
            });
          });
        });
        removes.forEach(function (key) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          });
        });
        if (adds.length) {
          chain = chain.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: adds })
            }).then(function (r) {
              if (r && r.ok) {
                /* Mark ONLY after Shopify accepts the add — on failure we
                   want the next pass to retry rather than silently skip. */
                postAddMarks.forEach(function (pair) { markAdded(pair[0], pair[1]); });
              }
              return r;
            });
          });
        }
        return chain.then(refreshVisibleCart).catch(function () {});
      })
      .finally(function () {
        busy = false;
        if (queued) { queued = false; setTimeout(run, 100); }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 50); });
  } else {
    setTimeout(run, 50);
  }
  document.addEventListener('pm:cart-drawer:open', run);
  document.addEventListener('pm:cart:mutated',     run);
})();

/* ==============================================================
   Spend-GWP progress upsell popup — on add-to-cart only.

   Pulls tier definitions from the SAME JSON blob the auto-add
   reconciler reads. After each pm:cart:added event:
     1. Re-fetch /cart.js (fresh, cache-busted).
     2. Compute paid subtotal (same formula as the reconciler).
     3. For each tier whose paid < threshold AND whose upsells
        list is non-empty, render a stacked tier block in the
        popup (nearest tier first).
     4. If anything to show AND the shopper hasn't dismissed
        this session → open the popup.

   Dismiss click sets a sessionStorage flag; popup stays hidden
   for the rest of the session.

   Add-to-cart buttons inside the popup POST /cart/add.js like
   any other add; they re-trigger pm:cart:added, so the popup
   updates (or closes) to reflect the new cart.
   ============================================================== */
(function () {
  var cfgEl   = document.getElementById('pnm-spend-gwp-auto-add');
  var popupEl = document.getElementById('pnm-sgwp-popup');
  if (!cfgEl || !popupEl) return;
  var tiers;
  try { tiers = JSON.parse(cfgEl.textContent || '[]'); } catch (e) { return; }
  if (!Array.isArray(tiers) || !tiers.length) return;

  var DISMISS_KEY = 'pnm_sgwp_popup_dismissed_v1';
  var tiersWrap = popupEl.querySelector('[data-sgwp-tiers]');
  var busy = false;

  function isDismissed() {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (_) { return false; }
  }
  function markDismissed() {
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (_) {}
  }

  function hide() {
    popupEl.classList.remove('is-open');
    popupEl.setAttribute('aria-hidden', 'true');
    /* Delay hidden attr so the fade-out transition finishes. */
    setTimeout(function () { popupEl.setAttribute('hidden', ''); }, 220);
  }
  function show() {
    popupEl.removeAttribute('hidden');
    popupEl.setAttribute('aria-hidden', 'false');
    /* Next frame so the browser applies the hidden-removal before the
       is-open class triggers the transition. */
    requestAnimationFrame(function () { popupEl.classList.add('is-open'); });
  }

  function fmtMoneyCents(cents) {
    var symbol = (document.body.getAttribute('data-currency-symbol') || '€');
    var n = (parseInt(cents, 10) || 0) / 100;
    return symbol + n.toFixed(2);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderTier(t, paidCents) {
    var remaining    = Math.max(0, (t.threshold_cents || 0) - paidCents);
    var pct          = Math.max(0, Math.min(100, Math.round((paidCents / (t.threshold_cents || 1)) * 100)));
    var eyebrow      = t.popup_headline || 'ALMOST THERE';
    var title        = t.popup_title    || "You're almost there.";
    var remMoney     = fmtMoneyCents(remaining);
    /* Body copy — admin-set wins; otherwise auto-generate the progress
       line. [remaining] token in the admin copy is swapped for the live
       amount, so merchants can bake the copy they want while still
       showing the dynamic value. */
    var body;
    if (t.popup_body) {
      body = escapeHtml(t.popup_body)
        .replace(/\[remaining\]/g, '<b>' + escapeHtml(remMoney) + '</b>')
        .replace(/\[threshold\]/g, '<b>' + escapeHtml(t.threshold_money || '') + '</b>')
        .replace(/\[worth\]/g,     '<b>' + escapeHtml(t.worth_money    || '') + '</b>');
    } else {
      body = 'Add <b>' + escapeHtml(remMoney) + '</b> more to unlock a free gift.';
    }
    var badgeText = t.bonus_badge || 'FREE';

    /* Hero image mode — if the admin picked a Popup image on the tier,
       render that as a single large hero tile INSTEAD of the per-product
       grid. First-choice merchants want to control the exact artwork
       (lifestyle shot, campaign still, etc.) rather than fall back to
       the gift's featured image. */
    var tilesHtml = '';
    var firstGift = (Array.isArray(t.tiles) ? t.tiles : [])[0] || null;
    if (t.popup_image) {
      var heroUrl = firstGift ? firstGift.url : (t.cta_url || '#');
      tilesHtml =
        '<a class="sgwp-pop__hero" href="' + escapeHtml(heroUrl) + '">' +
          '<img class="sgwp-pop__hero-img" loading="lazy" src="' + escapeHtml(t.popup_image) + '" alt="' + escapeHtml(t.popup_title || 'Free gift') + '">' +
          '<span class="sgwp-pop__badge">' + escapeHtml(badgeText) + '</span>' +
        '</a>';
    } else {
      var tiles = Array.isArray(t.tiles) ? t.tiles : [];
      tiles.forEach(function (p, i) {
        if (i > 0) tilesHtml += '<span class="sgwp-pop__plus" aria-hidden="true">+</span>';
        tilesHtml += '' +
          '<a class="sgwp-pop__tile" href="' + escapeHtml(p.url) + '" title="' + escapeHtml(p.title) + '">' +
            (p.image ? '<img class="sgwp-pop__tile-img" loading="lazy" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '">' : '') +
            (p.is_gift ? '<span class="sgwp-pop__badge">' + escapeHtml(badgeText) + '</span>' : '') +
          '</a>';
      });
    }

    var ctaLabel     = t.cta_label     || 'SHOP MORE';
    var ctaUrl       = t.cta_url       || '';
    var dismissLabel = t.dismiss_label || 'NO THANKS';
    var ctaHtml = ctaUrl
      ? '<a class="sgwp-pop__cta" href="' + escapeHtml(ctaUrl) + '">' + escapeHtml(ctaLabel) + '</a>'
      : '<button type="button" class="sgwp-pop__cta" data-sgwp-dismiss>' + escapeHtml(ctaLabel) + '</button>';

    return '' +
      '<div class="sgwp-pop__tier">' +
        /* Black header band — eyebrow + title. */
        '<p class="sgwp-pop__eyebrow">' + escapeHtml(eyebrow) + '</p>' +
        '<h2 class="sgwp-pop__title">' + escapeHtml(title) + '</h2>' +
        /* White body — message, progress, tiles, CTA, dismiss. */
        '<div class="sgwp-pop__body-wrap">' +
          '<p class="sgwp-pop__body">' + body + '</p>' +
          '<div class="sgwp-pop__bar"><div class="sgwp-pop__bar-fill" style="width:' + pct + '%"></div></div>' +
          (tilesHtml ? '<div class="sgwp-pop__row">' + tilesHtml + '</div>' : '') +
          ctaHtml +
          '<button type="button" class="sgwp-pop__dismiss" data-sgwp-dismiss>' + escapeHtml(dismissLabel) + '</button>' +
        '</div>' +
      '</div>';
  }

  function evaluateAndMaybeShow() {
    if (busy) return;
    if (isDismissed()) return;
    busy = true;
    fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        var paid = 0;
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          var linePaid = (typeof it.final_line_price === 'number' ? it.final_line_price : null);
          if (linePaid == null) linePaid = (typeof it.line_price === 'number' ? it.line_price : null);
          if (linePaid == null) linePaid = (it.price || 0) * (it.quantity || 0);
          /* Same free-gift discriminator as the reconciler above —
             only skip when the line is actually a free item, not
             just because it has `_gwp_parent_id` (routine upsells
             have that flag but are paid). */
          var isFreeGift = !!p._spend_gwp_tier_id
            || p._spend_gwp_free === '1'
            || p._gwp_free === '1'
            || (!!p._gwp_parent_id && (linePaid || 0) <= 0);
          if (isFreeGift) return;
          paid += linePaid;
        });
        /* Nearest first — ascending threshold, keep only tiers whose
           threshold isn't yet met AND which have at least one upsell
           product configured (nothing to pitch otherwise). */
        var sorted = tiers.slice().sort(function (a, b) {
          return (a.threshold_cents || 0) - (b.threshold_cents || 0);
        });
        var unmet = sorted.filter(function (t) {
          if ((t.threshold_cents || 0) <= paid) return false;
          return Array.isArray(t.tiles) && t.tiles.length > 0;
        });
        if (!unmet.length) { hide(); return; }
        tiersWrap.innerHTML = unmet.map(function (t) { return renderTier(t, paid); }).join('');
        show();
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  /* Dismiss handlers (close button, scrim click, "NO THANKS" link, and
     the primary CTA when no CTA URL is configured). Links with hrefs
     navigate normally — we don't intercept them. */
  popupEl.addEventListener('click', function (e) {
    var tgt = e.target;
    if (tgt && tgt.closest && tgt.closest('[data-sgwp-dismiss]')) {
      markDismissed();
      hide();
    }
  });

  /* Escape key closes without session-dismissing (user may want it back on next add). */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popupEl.classList.contains('is-open')) hide();
  });

  /* Only fires after real adds (not removes, qty changes, or page loads). */
  document.addEventListener('pm:cart:added', function () {
    /* Debounce slightly so the add has fully settled server-side. */
    setTimeout(evaluateAndMaybeShow, 350);
  });
})();
